function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.25 5.5H20.625L20.1562 4.65625C19.9688 4.28125 19.5938 4 19.1719 4H13.7812C13.3594 4 12.9844 4.28125 12.7969 4.65625L12.375 5.5H6.75C6.32812 5.5 6 5.875 6 6.25V7.75C6 8.17188 6.32812 8.5 6.75 8.5H26.25C26.625 8.5 27 8.17188 27 7.75V6.25C27 5.875 26.625 5.5 26.25 5.5ZM8.48438 25.8906C8.53125 27.1094 9.51562 28 10.7344 28H22.2188C23.4375 28 24.4219 27.1094 24.4688 25.8906L25.5 10H7.5L8.48438 25.8906Z",
  fill: "#D5D7DE"
});

var SvgTrashcan = function SvgTrashcan(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashcan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashcan.22c07fe6.svg";
export { ForwardRef as ReactComponent };